import { Checkbox, FormControlLabel, Grid, SxProps, TextField } from '@mui/material';
import { FC, MouseEvent, PropsWithChildren } from 'react';

type ViewDetailProps = PropsWithChildren<{
  value: React.ReactNode;
  columns?: number;
  checkbox?: boolean;
  labelPlacement?: 'bottom' | 'top' | 'end' | 'start';
  sx?: SxProps;
}>;

const ViewDetail: FC<ViewDetailProps> = ({ value = '', children, checkbox, columns = 2, labelPlacement = 'top', sx }) => {
  const disabled = { inputProps: { tabIndex: -1, onMouseDown: (e: MouseEvent) => e.preventDefault() } };
  const props = !checkbox
    ? { value, control: <TextField {...disabled} fullWidth size="small" /> }
    : { checked: !!value, control: <Checkbox {...disabled} sx={{ padding: '8px' }} /> };
  return (
    <Grid item sm={columns}>
      <FormControlLabel
        aria-disabled
        componentsProps={{ typography: { color: 'grey.700', fontWeight: 500, fontSize: 14 } }}
        label={children}
        labelPlacement={labelPlacement}
        sx={{ alignItems: 'flex-start', width: '100%', ...sx }}
        {...props}
      />
    </Grid>
  );
};

export default ViewDetail;
